import { Component, Input } from '@angular/core';
import lodash from 'lodash';



@Component({
  selector: 'app-page-body',
  template: `<ng-content></ng-content>`,
  host: {
    '[class]': '"d-" + display + " flex-column flex-nowrap rounded-3 p-3 bg-white"',
    style: 'border: 1px solid #E6E9EC;'
  }
})
export class PageBodyComponent {
  @Input() set display(value: string) {
    this._display = lodash.trim(value) || 'flex';
  };

  get display(): string {
    return this._display;
  };

  private _display: string = 'flex';
}
